export default "__VITE_ASSET__Cvv3TFso__";